<template>
    <div class="help">
        <el-link :underline="false" type="danger" icon="el-icon-help" @click="handleOpenHelp">
            Pomoc
        </el-link>
        <el-dialog title="Pomoc" width="80%" @close="handleCloseHelp" :visible="showHelp" :close-on-click-modal="false">
            <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Totam, error cum! Ea minus impedit nihil saepe esse porro deleniti ab eveniet ipsam rem quisquam tempora cupiditate veniam, vel in hic?</p>
        </el-dialog>
    </div>
</template>

<script>
export default {
    data() {
        return {
            showHelp: false
        }
    },
    methods: {
        handleOpenHelp() {
            this.showHelp = true
        },
        handleCloseHelp() {
            this.showHelp = false

            // Prevent opening help modal every time
            localStorage.shownHelp = true
        }
    },
    mounted() {
        // If first visit show modal with help
        if (!localStorage.shownHelp) {
            this.handleOpenHelp()
        }
    }
}
</script>